import React, {useEffect, useState} from "react";

const Iframe = (props) => {

    const {
        src,
        onHeightChange,
        onLoad
    } = props;

    const [iframeHeight, setIframeHeight] = useState(300);

    const _onLoad = () => {
        if(typeof onLoad === 'function') {
            onLoad();
        }
    }

    useEffect(() => {

        const postMessageHandler = (ev) => {
            if (typeof ev.data !== 'object' || !ev.data.height) {
                return;
            }
            setIframeHeight( ev.data.height + 20 );
        }

        window.addEventListener('message', postMessageHandler);

        // Don't forget to remove addEventListener
        return () => window.removeEventListener('message', postMessageHandler)

    }, []);

    useEffect(() => {
        if(iframeHeight && typeof onHeightChange === 'function') {
            onHeightChange( iframeHeight );
        }
    // eslint-disable-next-line
    }, [iframeHeight]);

    return (
        <iframe
            src={src}
            width={'100%'}
            height={iframeHeight}
            title={`lead-form`}
            scrolling="no"
            frameBorder="0"
            style={{
                height: iframeHeight + 'px'
            }}
            onLoad={ _onLoad }
        />
    )
}

export default Iframe;